<template lang="pug">
div(v-if="patient && patient.name")
  v-card.round-xl(outlined)
    //- profile section
    v-row.pa-4(dense)
      v-col.shrink
        v-img.round-xl(v-if="patient.profile_image" width="60" height="80" :src="$options.filters.mediumImage(patient.profile_image.file)" cover)
          template(v-slot:placeholder)
            v-row(class="fill-height ma-0" align="center" justify="center")
              v-progress-circular(indeterminate color="grey")
        v-card.neutral300.fill-height.round-xl(v-else flat width="60" height="80")
          div.d-flex.align-center.justify-center.fill-height
            v-icon(size="30") $yzi-user-03
      v-col
        div.text-sm.font-medium.neutral700--text {{ patient.name }}
        div.text-xs.neutral500--text(v-if="patient.dob") {{ $options.filters.getAgeByYearMonthDay(patient.dob) | displayAgeByYearMonthDay }} old
        div.text-xs.neutral500--text.mt-1 {{ patient.ic }}
      v-col.shrink
        y-button(label="View profile" outlined color="neutral400" text-color="neutral700" size="xxs" height="24" unset-min-width button-class="px-2" @click="onOpenProfileWindow")
    v-divider
    //- billing section
    div.pa-4
      billing-section
</template>

<script>
import { mapGetters } from 'vuex'
import BillingSection from '@/components/clinic/checkout/BillingSection.vue'

export default {
  components: { BillingSection },
  computed: {
    ...mapGetters({
      patient: 'reservationPreorder/getPatient',
      isHq: 'hq/getIsHq',
    }),
  },
  methods: {
    onOpenProfileWindow () {
      const link = this.isHq ? `/admin/hq/patient/${this.patient.ic}` : `/admin/clinic/patient/${this.patient.id}`
      window.open(link, '_blank')
    },
  }
}
</script>
